module.exports = __webpack_public_path__ + "media/images/pic/students_number-3efdb2f8b1779f3afb3cebd4831b11f2.svg";